import { useEffect, useState } from 'react';

const getScrollTop = (): number => {
  const el = document.scrollingElement || document.documentElement;
  return el ? el.scrollTop : 0;
};

const getIsScrolling = () => getScrollTop() > 0;

const useScroll = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const newIsScrolling = getIsScrolling();

      setIsScrolling((oldIsScrolling) => {
        if (oldIsScrolling !== newIsScrolling) {
          return newIsScrolling;
        }
        return oldIsScrolling;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isScrolling;
};

export default useScroll;
